import { createTheme } from '@mui/material/styles'

// アプリケーション全体で一貫したデザインを提供するためのカスタムテーマ
// 配色ルール:
// Base: #FFFFFF | Base Sub: #F7F8FA
// Primary: #1F3A5F（ネイビー） | Secondary: #2C6EBE（ブルー） | Accent: #3FB984（グリーン）
// Text Main: #111827 | Text Body: #374151 | Border: #E5E7EB
const theme = createTheme({
  // カラーパレットの設定
  palette: {
    primary: {
      main: '#1F3A5F', // プライマリカラー（ネイビー）
      light: '#4A6FA5',
      dark: '#152A45',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2C6EBE', // セカンダリカラー（ブルー）
      light: '#5A9BD5',
      dark: '#1E4F8A',
      contrastText: '#ffffff',
    },
    success: {
      main: '#3FB984', // アクセントカラー（グリーン）
      light: '#6DCDA6',
      dark: '#2D8A62',
      contrastText: '#ffffff',
    },
    background: {
      default: '#F7F8FA', // Base Sub（全体の背景色）
      paper: '#FFFFFF', // Base（カードやダイアログなどの背景色）
    },
    text: {
      primary: '#111827', // Text Main
      secondary: '#374151', // Text Body
    },
    divider: '#E5E7EB', // Border
  },

  // タイポグラフィ（フォントスタイル）の設定
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 700 },
    h2: { fontSize: '2rem', fontWeight: 700 },
    h3: { fontSize: '1.75rem', fontWeight: 700 },
    h4: { fontSize: '1.5rem', fontWeight: 600 },
    h5: { fontSize: '1.25rem', fontWeight: 600 },
    h6: { fontSize: '1rem', fontWeight: 600 },
    button: {
      textTransform: 'none', // ボタンのテキストを大文字にしない
      fontWeight: 600,
    },
  },

  // 角の丸みの設定
  shape: {
    borderRadius: 8,
  },

  // コンポーネントごとのデフォルトスタイル上書き
  components: {
    // AppBarのスタイル
    MuiAppBar: {
      styleOverrides: {
        root: {
          elevation: 0, // AppBarの影をなくす
          backgroundColor: '#1F3A5F', // Primary（ネイビー）
          borderBottom: 'none',
          color: '#FFFFFF', // 白文字
        },
      },
    },
    // Buttonのスタイル
    MuiButton: {
      defaultProps: {
        disableElevation: true, // ボタンの影をなくす
      },
      styleOverrides: {
        root: {
          padding: '8px 22px',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#152A45', // Primary dark
          },
        },
      },
    },
    // Cardのスタイル
    MuiCard: {
      styleOverrides: {
        root: {
          elevation: 1, // カードに少しだけ影をつける
          border: '1px solid #E5E7EB', // Border
        },
      },
    },
    // Paperのスタイル（Cardなどもこれに依存）
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          //
        },
      },
    },
    // ListItemButtonのスタイル（サイドバーなどで使用）
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(31, 58, 95, 0.08)', // Primary with low opacity
            borderRight: '3px solid #1F3A5F', // Primary
            '&:hover': {
              backgroundColor: 'rgba(31, 58, 95, 0.12)', // Slightly darker on hover
            },
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)', // Default hover
          },
        },
      },
    },
    // ListItemIconのスタイル（サイドバーなどで使用）
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          // Reset color to inherit from parent.
          // In a selected ListItemButton, the text color becomes primary, so the icon will too.
          color: 'inherit',
        },
      },
    },
  },
})

export default theme
